import React from "react";

const Disclaimer = (props) => {
  return (
    <div className="disclaimer">
      <p>
      I understand that this information is not intended to replace medical advice,
      and that it is only meant to allow for informed patient-physician conversations.
      </p>
      <button className="game-input-btn" onClick={props.close}>Agree</button>
    </div>
  );
}

export default Disclaimer;